import { render, staticRenderFns } from "./SearchPhonePage.vue?vue&type=template&id=5ec4840f&"
import script from "./SearchPhonePage.vue?vue&type=script&lang=js&"
export * from "./SearchPhonePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports